import React from "react";

const Error404 = () => {
  return (
    <div className="w-1/2 mx-auto mb-40">
      <h1 className="text-center text-3xl ">
        The page your are looking for not found
      </h1>
      <img src="https://img.freepik.com/free-vector/error-404-concept-illustration_114360-1811.jpg?w=740&t=st=1669569281~exp=1669569881~hmac=f05917c228a8f4c9be3be4e0365c4eef188039fd08fccf31261a5cc0c47bd6c7"></img>
    </div>
  );
};

export default Error404;
